import React, {Component} from 'react';
import {Form, Control, actions} from 'react-redux-form';
import {connect} from 'react-redux';
import {Button, Grid, Row, Col} from 'react-bootstrap';
import SecurityQuestionAnswer from '../../../common/form/user/security-question-answer-input'
import PageTitle from "../../../common/page-title/index";
import BackLink from "../../../common/back-link/index";
import ArrowButton from "../../../common/button-arrow";
import {updateSecurityQuestionsForOwner} from '../../../../actions/update-security-questions';
import {getQuestions} from '../../../../actions/about-you'
import {getUserDetails} from '../../../../actions/users'

class UpdateSecurityQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.id = +this.props.match.params.id;
    this.props.dispatch(getUserDetails(this.id)).
      then(() => {
      this.props.dispatch(actions.change('deep.updateSecQ.owner.security_answers_attributes[0].id', this.props.user.relationships['security-answers'].data[0].id));
      this.props.dispatch(actions.change('deep.updateSecQ.owner.security_answers_attributes[1].id', this.props.user.relationships['security-answers'].data[1].id));
    });
    this.props.dispatch(getQuestions());
  }

  updateErrors = (field, value) => {
    this.setState({[field]: value});
  };

  onSaveClicked = (payload) => {
    this.props.dispatch(actions.submitFields('deep.updateSecQ.owner', updateSecurityQuestionsForOwner(this.id, payload)));
  };

  render() {
    return (
      <Form
        model="deep.updateSecQ.owner"
        onSubmit={this.onSaveClicked}>
        <Grid fluid className="update-security-questions">
          <Row>
            <Col lg={12}>
              <BackLink href={`/admin/users/${this.id}/details`}/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <PageTitle>Update security questions</PageTitle>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <SecurityQuestionAnswer
                questions={this.props.questions.filter(question => question.attributes['list-number'] === 1)}
                questionModel=".security_answers_attributes[0].security_question_id"
                answerModel=".security_answers_attributes[0].answer"
                questionControlId="userSecurityQuestion1"
                answerControlId="userSecurityAnswer1"/>

              <SecurityQuestionAnswer
                questions={this.props.questions.filter(question => question.attributes['list-number'] === 2)}
                questionModel=".security_answers_attributes[1].security_question_id"
                answerModel=".security_answers_attributes[1].answer"
                questionLabel="Security question 2"
                answerLabel="Security answer 2"
                answerPlaceHolder="Security answer 2"
                questionControlId="userSecurityQuestion2"
                answerControlId="userSecurityAnswer2"/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ArrowButton color="red"
                           className="pull-right"
                           arrow={false}>Save</ArrowButton>
            </Col>
          </Row>
        </Grid>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    questions: state.aboutYou.questions,
    user: state.users.user,
  };
};

export default connect(mapStateToProps)(UpdateSecurityQuestions);


// WEBPACK FOOTER //
// ./src/components/admin/users/edit/update-security-question.jsx